import * as React from 'react';
import { TooltipIcon } from 'src/components';
import { IGridElement, ITargetUrlOptions } from '../types';

interface ITooltipProps {
  cell: IGridElement;
  isTargetUrl: boolean;
  targetUrl?: ITargetUrlOptions;
}

export const Tooltips = ({ cell, isTargetUrl, targetUrl }: ITooltipProps) => {
  if (cell.error) {
    return (
      <TooltipIcon
        className="ml-2 text-xs"
        positionY="top"
        positionX="right"
        type="error"
        width="w-32"
        text={cell.error}
      />
    );
  }
  if (isTargetUrl) {
    if (targetUrl && targetUrl.result && !targetUrl.checking) {
      return (
        <TooltipIcon
          className="ml-2 text-xs"
          positionY="top"
          positionX="right"
          type={targetUrl.result.success ? 'success' : 'warning'}
          width={targetUrl.result.success ? 'w-16' : 'w-48'}
          text={targetUrl.result.message}
        />
      );
    }
    return (
      <TooltipIcon
        className="ml-2 text-xs"
        positionY="top"
        positionX="right"
        type={targetUrl && targetUrl.checking ? 'loading' : 'info'}
        width="w-32"
        text={
          targetUrl && targetUrl.checking
            ? 'Checking Target URL'
            : 'Not checked yet'
        }
        isLoading={targetUrl && targetUrl.checking}
      />
    );
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulk/components/Tooltips.tsx